
































































import Vue from 'vue'

export default Vue.extend({
    name: 'Approvals',
    metaInfo: {
        title: 'Approvals',
        meta : [
            {
                name: 'description',
                content : 'Approvals'
            },
            {
                name: 'keywords',
                content : 'Approvals, retrofitting, cyclone, weather, storm, protection'
            }
        ]
    },
    data: () => ({

    }),
    computed: {

    },
})
